"use client";
import React from "react";
import Link from "next/link";

const HeroModern = ({ onGetDemo }) => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center bg-gradient-to-br from-[#F3F1FA] to-[#E8E4F3] overflow-hidden pt-20">
      {/* Gradient background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-accent/10 rounded-full blur-[128px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-accent-light/10 rounded-full blur-[100px]" />
        <div className="absolute top-1/2 right-1/3 w-[300px] h-[300px] bg-accent/5 rounded-full blur-[80px]" />
      </div>

      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `linear-gradient(rgba(131,88,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(131,88,255,.1) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 border border-accent/20 backdrop-blur-sm mb-8 shadow-sm">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <span className="text-sm text-jacarta-600">AI-Powered Recruitment Platform</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-tight tracking-tight">
          <span className="text-jacarta-700">AI Interviews</span>
          <br />
          <span className="bg-gradient-to-r from-accent via-accent-dark to-accent bg-clip-text text-transparent">
            for BFSI
          </span>
        </h1>

        {/* Subtitle */}
        <p className="mt-8 text-lg md:text-xl text-jacarta-500 max-w-2xl mx-auto leading-relaxed">
          Screen, qualify, and interview candidates at superhuman speed. 
          Our AI conducts interviews that feel human—delivered 10x faster.
        </p>

        {/* CTA Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={() => onGetDemo && onGetDemo()}
            className="group relative px-8 py-4 bg-accent hover:bg-accent-dark rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg hover:shadow-accent/25 hover:scale-105"
          >
            Get a Demo
            <span className="absolute inset-0 rounded-xl bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
          
          <div className="relative group/signin">
            <button className="px-8 py-4 rounded-xl font-semibold text-jacarta-600 border border-jacarta-200 hover:bg-white hover:border-accent/30 transition-all duration-300 flex items-center gap-2">
              Sign In
              <svg className="w-4 h-4 transition-transform group-hover/signin:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            
            <div className="invisible absolute left-1/2 -translate-x-1/2 top-full mt-2 z-50 min-w-[240px] translate-y-2 rounded-2xl border border-gray-100 bg-white p-3 opacity-0 shadow-2xl transition-all group-hover/signin:visible group-hover/signin:translate-y-0 group-hover/signin:opacity-100">
              <Link href="/corporate/login">
                <a className="flex flex-col py-3 px-4 hover:bg-accent/5 rounded-xl transition-colors text-left w-full group/item">
                  <span className="font-bold text-jacarta-700 block group-hover/item:text-accent transition-colors">Corporate Login</span>
                  <span className="text-xs text-jacarta-500 block">For employers & recruiters</span>
                </a>
              </Link>
              <div className="my-2 border-t border-gray-50"></div>
              <Link href="/candidate/login">
                <a className="flex flex-col py-3 px-4 hover:bg-accent/5 rounded-xl transition-colors text-left w-full group/item">
                  <span className="font-bold text-jacarta-700 block group-hover/item:text-accent transition-colors">Candidate Login</span>
                  <span className="text-xs text-jacarta-500 block">For job seekers</span>
                </a>
              </Link>
            </div>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 pt-8 border-t border-jacarta-100">
          <p className="text-sm text-jacarta-400 mb-4">Trusted by leading BFSI companies</p>
          <div className="flex items-center justify-center gap-8">
            <div className="text-jacarta-500 text-sm font-medium">Banking</div>
            <div className="w-1 h-1 bg-accent/40 rounded-full" />
            <div className="text-jacarta-500 text-sm font-medium">Finance</div>
            <div className="w-1 h-1 bg-accent/40 rounded-full" />
            <div className="text-jacarta-500 text-sm font-medium">Insurance</div>
            <div className="w-1 h-1 bg-accent/40 rounded-full" />
            <div className="text-jacarta-500 text-sm font-medium">Fintech</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroModern;
